import Repository from "./RepositoryFactoryMain";
const ADD_VARIATION = "create";
const UPDATE_VARIATION = "update";
const DELETE_VARIATION = "delete";
const GET_VARIATION = "get";
const GET_DETAILED_CATEGORY = "getDetailedCategory";
const PRODUCT_IMAGE = "addProductImage";

export default {
  addVariation(payload) {
    return Repository.post(transformRoute(ADD_VARIATION), payload);
  },
  updateVariation(payload) {
    return Repository.post(transformRoute(UPDATE_VARIATION), payload);
  },
  getVariation(payload) {
    return Repository.post(transformRoute(GET_VARIATION), payload);
  },
  deleteVariation(payload) {
    return Repository.post(transformRoute(DELETE_VARIATION), payload);
  },
  getDetailedCategory() {
    return Repository.post(transformRoute(GET_DETAILED_CATEGORY));
  },
  productImage(payload) {
    return Repository.post(transformRoute(PRODUCT_IMAGE), payload);
  },
};

const transformRoute = (route) => {
  return `/ecom/variation/${route}`;
};
